import React from "react";
import { Router, Route, IndexRoute, browserHistory } from "react-router";
import logger from "redux-logger";
import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { Provider } from "react-redux";
// Reducers
import reducers from "../reducers";

// Components
import Layout from "../components/common/Layout";
import Login from "../components/pages/Login";
import Backtest from "../components/pages/Backtest";
import Live from "../components/pages/Live";
// import Sim from "../components/pages/Sim";
// import CreateEdit from "../components/pages/CreateEdit";
import Create from "../components/pages/Create";
// import CreateNew from "../components/pages/CreateNew";
// import CreatePortfolio from "../components/pages/CreatePortfolio";
import Portfolio from "../components/pages/Portfolio";

import Dashboard from "../components/pages/portfolioDashboard";
import Portfolios from "../components/pages/MyPortfolios";
import "../../node_modules/font-awesome/css/font-awesome.min.css";
import ComparePortfolio from "../components/pages/ComparePortfolio";
import Retire from "../components/pages/Retire";
import MyUniverse from "../components/pages/MyUniverse/universe";
import CreatePortfolioByAdisor from "../components/pages/Create_portfolio_by_Advisor";
import MyClients from "../components/pages/MyClients";
import RiskQuestionnaire from "../components/pages/Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire/RiskQuestionnaire";
import RiskQuestionnaireHolder from "../components/pages/RiskQuestionnaireHolder";

const store = createStore(reducers, applyMiddleware(logger, thunkMiddleware));
store.dispatch({ type: "CHECK_LOGIN" });

function loggedIn() {
  let state = store.getState();
  return state.user.isAuth;
}

function requireAuth(nextState, replace) {
  if (!loggedIn()) {
    const { pathname } = window.location;
    const redirectTo =
      pathname.length && pathname !== "/login"
        ? "/login?back=" + pathname
        : "/login";

    replace({
      pathname: redirectTo,
    });
  }
}

export default (
  <Provider store={store}>
    <Router history={browserHistory}>
      <Route path="/login" component={Login} />
      <Route path="/" component={Layout} onEnter={requireAuth}>
        <IndexRoute component={Portfolios} />
        <Route path="backtest" component={Backtest} />
        <Route path="backtest/:id" component={Backtest} />
        <Route path="create" component={Create} />
        <Route path="portfolio/:id" component={Portfolio} />
        <Route path="compare" component={ComparePortfolio} />
        <Route path="dashboard" component={Dashboard} />
        <Route path="myportfolios" component={Portfolios} />
        <Route path="retire" component={Retire} />
        <Route path="myuniverse" component={MyUniverse} />
        <Route path="myclients" component={MyClients} />
        <Route path="riskQuestionnaire" component={RiskQuestionnaireHolder} />
        {/* <Route path={`buildPortfolio`} component={CreatePortfolioByAdisor} /> */}
        <Route
          path={`buildPortfolio/:portfolioType`}
          component={CreatePortfolioByAdisor}
        />
        {/* <Route path="sim" component={Sim} /> */}
        {/* <Route path="create_edit" component={CreateEdit} /> */}
        {/* <Route path="create_portfolio" component={CreateNew} /> */}
        {/* <Route path="create_portfolio_old" component={CreatePortfolio} /> */}

        {/* if not default path*/}
        <Route path="/*" component={Live} />
      </Route>
    </Router>
  </Provider>
);



// WEBPACK FOOTER //
// ./src/route/index.js